import {
    APP_STYLE_COMPONENT_COLORS as MSI_COMPONENT_COLORS,
    MSI_GEOMETRY,
    APP_STYLE_PALETTE as MSI_PALETTE,
    MSI_TYPE_SCALE,
    usesAppStyleGrammar,
} from '../styles/msiStyleTokens';
import { alpha } from '@mui/material/styles';
import { workspacePanelElevationSx } from '../styles/workspaceChromeStyles';

/**
 * Risk Overview tab styling constants. (Its tables take the optimized-column
 * tint from the table kit: data_table/tableClasses.js optimizedCellClassName.)
 */

// Solid bar colors for sector/factor charts, from the semantic tokens, so
// Semantic Colors overrides apply everywhere consistently.
export const ACTUAL_BAR_COLOR = 'rgb(var(--c-actual))';
export const OPTIMIZED_BAR_COLOR = 'rgb(var(--c-optimized))';

export const riskOverviewPanelSx = {
    ...workspacePanelElevationSx,
    borderColor: (theme) => (usesAppStyleGrammar(theme) ? MSI_PALETTE.line : undefined),
    borderRadius: (theme) => (usesAppStyleGrammar(theme) ? `${MSI_GEOMETRY.radii.panel}px` : undefined),
    backgroundColor: (theme) => (usesAppStyleGrammar(theme) ? MSI_PALETTE.surface : undefined),
    backgroundImage: (theme) => (usesAppStyleGrammar(theme) ? 'none' : undefined),
};

export const riskOverviewSecondaryControlSx = {
    border: (theme) => (
        usesAppStyleGrammar(theme) ? `1px solid ${MSI_PALETTE.lineDark}` : undefined
    ),
    borderRadius: (theme) => (
        usesAppStyleGrammar(theme) ? `${MSI_GEOMETRY.radii.button}px` : undefined
    ),
    backgroundColor: (theme) => (usesAppStyleGrammar(theme) ? MSI_PALETTE.surface : undefined),
    color: (theme) => (usesAppStyleGrammar(theme) ? MSI_PALETTE.ink700 : undefined),
    '&:hover': {
        borderColor: (theme) => (
            usesAppStyleGrammar(theme) ? MSI_COMPONENT_COLORS.secondaryHoverBorder : undefined
        ),
        backgroundColor: (theme) => (
            usesAppStyleGrammar(theme) ? MSI_COMPONENT_COLORS.secondaryHover : undefined
        ),
        color: (theme) => (usesAppStyleGrammar(theme) ? MSI_PALETTE.ink900 : undefined),
    },
};

export function getRiskOverviewTooltipStyle(theme) {
    if (usesAppStyleGrammar(theme)) {
        return {
            background: MSI_PALETTE.surface,
            border: `1px solid ${MSI_PALETTE.line}`,
            borderRadius: MSI_GEOMETRY.radii.panel,
            boxShadow: '0 8px 24px rgba(12, 23, 38, 0.12)',
            padding: 8,
            fontSize: MSI_TYPE_SCALE.helper.fontSize,
            color: MSI_PALETTE.ink900,
        };
    }

    return {
        background: theme.palette.background.paper,
        border: `1px solid ${alpha(theme.palette.divider, 0.95)}`,
        borderRadius: 10,
        boxShadow: theme.shadows[6],
        padding: 8,
        fontSize: '0.85rem',
        color: theme.palette.text.primary,
    };
}

export function getRiskOverviewChartChrome(theme) {
    if (!usesAppStyleGrammar(theme)) {
        return {
            grid: undefined,
            axis: alpha(theme.palette.divider, 0.8),
            reference: theme.palette.text.disabled,
            tick: theme.palette.text.secondary,
            tickFontSize: 12,
            cursor: undefined,
        };
    }

    return {
        grid: MSI_COMPONENT_COLORS.rowDivider,
        axis: MSI_PALETTE.lineDark,
        reference: MSI_PALETTE.ink400,
        tick: MSI_PALETTE.ink500,
        tickFontSize: MSI_TYPE_SCALE.helper.fontSize,
        cursor: MSI_COMPONENT_COLORS.rowHover,
    };
}
